import { DynamicForm, FormConfig } from "@components/DynamicForm/DynamicForm";
import { useNotification } from "@hooks/useNotification";
import { useQuery } from "@hooks/useQuery";
import { decodeHTML } from "@utils/CommonUtils";
import { useEffect } from "react";
import { FieldValues } from "react-hook-form";
import { useNavigate } from "react-router-dom";
import { useAuth } from "~/Hooks/useAuth";
import { useDocumentDetails } from "~/Modules/ECMS/MAGP/ApprovalManagement/Drilldown.Hooks";
import { post, put } from "~/Services";
import { eramanHost } from "~/Utils";
import { fields } from "../constants";
import { useAllTopHeaderDocuments } from "./TopHeader.hooks";

export const EditTopHeader = () => {
  const query = useQuery();
  const navigate = useNavigate();
  const { openToast } = useNotification();
  const { user } = useAuth();

  const {
    data: allTopHeaderDocs,
    isLoading: isLoadingTopHeaderData,
    refetch: refetchEditData,
  } = useAllTopHeaderDocuments();

  const {
    data: dataById,
    isLoading: isLoadingData,
    refetch: refetchDocument,
  } = useDocumentDetails(query?.get("id") || "");

  useEffect(() => {
    if (query.get("id")) {
      refetchDocument();
    }
    if (query.get("editId")) {
      refetchEditData();
    }
  }, [query.get("editId"), query.get("id")]);

  const topHeaderData = allTopHeaderDocs?.[0];

  const formConfig: FormConfig = {
    initialValues: {
      field_sign_in_text_en: decodeHTML(
        dataById
          ? dataById.payload.field_sign_in_text_en
          : allTopHeaderDocs
            ? allTopHeaderDocs?.[0].field_sign_in_text_en
            : ""
      ),
      field_sign_in_text_malay: decodeHTML(
        dataById
          ? dataById.payload.field_sign_in_text_malay
          : allTopHeaderDocs
            ? allTopHeaderDocs?.[0].field_sign_in_text_malay
            : ""
      ),
      field_sign_in_text_mandarin: decodeHTML(
        dataById
          ? dataById.payload.field_sign_in_text_mandarin
          : allTopHeaderDocs
            ? allTopHeaderDocs?.[0].field_sign_in_text_mandarin
            : ""
      ),

      field_register_en: decodeHTML(
        dataById ? dataById.payload.field_register_en : allTopHeaderDocs ? allTopHeaderDocs?.[0].field_register_en : ""
      ),
      field_register_ms: decodeHTML(
        dataById ? dataById.payload.field_register_ms : allTopHeaderDocs ? allTopHeaderDocs?.[0].field_register_ms : ""
      ),
      field_register_zh: decodeHTML(
        dataById ? dataById.payload.field_register_zh : allTopHeaderDocs ? allTopHeaderDocs?.[0].field_register_zh : ""
      ),

      field_location_text_en: decodeHTML(
        dataById
          ? dataById.payload.field_location_text_en
          : allTopHeaderDocs
            ? allTopHeaderDocs?.[0].field_location_text_en
            : ""
      ),
      field_location_text_malay: decodeHTML(
        dataById
          ? dataById.payload.field_location_text_malay
          : allTopHeaderDocs
            ? allTopHeaderDocs?.[0].field_location_text_malay
            : ""
      ),
      field_location_text_mandarin: decodeHTML(
        dataById
          ? dataById.payload.field_location_text_mandarin
          : allTopHeaderDocs
            ? allTopHeaderDocs?.[0].field_location_text_mandarin
            : ""
      ),

      field_wishlist_text_en: decodeHTML(
        dataById
          ? dataById.payload.field_wishlist_text_en
          : allTopHeaderDocs
            ? allTopHeaderDocs?.[0].field_wishlist_text_en
            : ""
      ),
      field_wishlist_text_malay: decodeHTML(
        dataById
          ? dataById.payload.field_wishlist_text_malay
          : allTopHeaderDocs
            ? allTopHeaderDocs?.[0].field_wishlist_text_malay
            : ""
      ),
      field_wishlist_text_mandarin: decodeHTML(
        dataById
          ? dataById.payload.field_wishlist_text_mandarin
          : allTopHeaderDocs
            ? allTopHeaderDocs?.[0].field_wishlist_text_mandarin
            : ""
      ),

      field_sign_in_icon_image: dataById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "field_sign_in_icon_image.png",
              status: "done",
              url: dataById?.payload?.field_sign_in_icon_image,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "field_sign_in_icon_image.png",
              status: "done",
              url: allTopHeaderDocs?.[0]?.field_sign_in_icon_image,
            },
          ]),

      field_location_icon_image: dataById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "field_location_icon_image.png",
              status: "done",
              url: dataById?.payload?.field_location_icon_image,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "field_location_icon_image.png",
              status: "done",
              url: allTopHeaderDocs?.[0]?.field_location_icon_image,
            },
          ]),

      field_wishlist_icon_image: dataById?.payload
        ? decodeHTML([
            {
              uid: "-1",
              name: "field_wishlist_icon_image.png",
              status: "done",
              url: dataById?.payload?.field_wishlist_icon_image,
            },
          ])
        : decodeHTML([
            {
              uid: "-1",
              name: "field_wishlist_icon_image.png",
              status: "done",
              url: allTopHeaderDocs?.[0]?.field_wishlist_icon_image,
            },
          ]),
    },
    fields: fields.topHeader,
  };

  const onSubmit = async (
    data: FieldValues,
    apiUrl: string,
    action: string,
    method: string,
    status: "DRAFT" | "PENDING",
    reviewNotes?: string
  ) => {
    console.log("data-123", data);
    let imageKeys: any = ["field_sign_in_icon_image", "field_location_icon_image", "field_wishlist_icon_image"];

    for (const key of imageKeys) {
      try {
        let field = data[key];
        if (field?.[0]?.originFileObj) {
          const formData = new FormData();
          formData.append("upload-file", field[0].originFileObj);
          formData.append("application", "ERAMAN");
          const res: any = await post("management/upload-file", formData);

          if (res) {
            data[key] = res.response.data;
          }
        } else if (field?.[0]?.url) {
          data[key] = field[0].url;
        } else {
          data[key] = ""; // fallback in case of invalid field
        }
      } catch (error) {
        console.error("Image processing failed for:", key, error);
      }
    }

    const payload = {
      action: action,
      method: method,
      module: "Header",
      subModule: "topHeader",
      type: "DEDICATED",
      application: "ERAMAN",
      reviewNotes: reviewNotes,
      appList: [
        {
          appName: "ERAMAN",
          apiUrl: apiUrl,
        },
      ],
      payload: {
        ...(action === "UPDATE" && { id: topHeaderData?.tid }),
        ...data,
        status: true,
        published: data.published,
      },
      status: status,
    };

    // Log the complete payload
    console.log("Final Payload:", payload);

    if (query.get("id")) {
      put(`/management/update-document?approvalId=${query.get("id")}`, payload)
        .then((response: any) => {
          openToast({
            content: status == "PENDING" ? "Data Sent for Review" : "Data Saved Successfully",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    } else {
      post(`/management/publish`, payload)
        .then((response: any) => {
          openToast({
            content: status == "DRAFT" ? "Data saved successfully" : "Data Sent for Review",
            type: "success",
          });
          if (response.status === "OK" && status == "PENDING") {
            navigate("/dedicated/status-information?activeTab=pending");
          } else {
            navigate("/dedicated/status-information?activeTab=draft");
          }
        })
        .catch((err: any) => {
          openToast({
            content: "Failed to save data",
            type: "error",
          });
        });
    }
  };

  return (
    <DynamicForm
      isLoading={isLoadingTopHeaderData || !formConfig}
      config={formConfig}
      onSubmit={(data, buttonValue, reviewNotes) =>
        onSubmit(
          data,
          `${eramanHost}/api/topheadermodule/${topHeaderData?.tid}`,
          "UPDATE",
          "PATCH",
          buttonValue == "save" ? "DRAFT" : "PENDING",
          reviewNotes
        )
      }
    />
  );
};
